export class WebAPI {
  /**
   * .envのREACT_APP_WEBAPIに設定されているWebAPIのURL
   */
  static readonly ROOT = process.env.REACT_APP_WEBAPI;

  static readonly ETAG = "etag=";

  static readonly PROJECTS = WebAPI.ROOT + "projects";
  static readonly GET_PROJECTS = WebAPI.PROJECTS;
  static readonly CREATE_PROJECT = WebAPI.PROJECTS;
  static UPDATE_PROJECT(projectid: string, etag?: string): string {
    let url = WebAPI.PROJECTS + "/" + projectid;
    if (etag && etag.length > 0) {
      url = url + "?" + this.ETAG + etag;
    }
    return url;
  }
  static DELETE_PROJECT(projectid: string, etag?: string): string {
    let url = WebAPI.PROJECTS + "/" + projectid;
    if (etag && etag.length > 0) {
      url = url + "?" + this.ETAG + etag;
    }
    return url;
  }
  static COPY_PROJECT(projectid: string, etag?: string): string {
    let url = WebAPI.PROJECTS + "/" + projectid + "/copy";
    if (etag && etag.length > 0) {
      url = url + "?" + this.ETAG + etag;
    }
    return url;
  }

  static readonly PARAM_PROJECTID = "?projectid=";

  static readonly FILES = WebAPI.ROOT + "files";
  static GET_FILES(projectid: string): string {
    return WebAPI.FILES + WebAPI.PARAM_PROJECTID + projectid;
  }
  static GET_FILE(projectid: string, fileid: string): string {
    return WebAPI.FILES + "/" + fileid + this.PARAM_PROJECTID + projectid;
  }
  static DELETE_FILE(projectid: string, fileid: string): string {
    return this.FILES + "/" + fileid + this.PARAM_PROJECTID + projectid;
  }
  static UPLOAD_FILE(projectid: string): string {
    return WebAPI.FILES + "/raw" + WebAPI.PARAM_PROJECTID + projectid;
  }
  static TRIMCOPY(projectid: string, fileid: string): string {
    return (
      WebAPI.FILES +
      "/" +
      fileid +
      "/trimcopy" +
      WebAPI.PARAM_PROJECTID +
      projectid
    );
  }
  static CHANNELS(projectid: string, fileid: string): string {
    return (
      WebAPI.FILES +
      "/" +
      fileid +
      "/channels" +
      WebAPI.PARAM_PROJECTID +
      projectid
    );
  }

  static readonly MODELS = WebAPI.ROOT + "models";
  static CREATE_MODEL(projectid: string): string {
    return WebAPI.MODELS + "/" + projectid;
  }
  static TEST_MODEL(projectid: string): string {
    return WebAPI.MODELS + "/" + projectid + "/tests";
  }
  static MODEL_PROPERTY(projectid: string): string {
    return WebAPI.MODELS + "/" + projectid + "/property";
  }
  static DOWNLOAD_MODEL(projectid: string): string {
    return WebAPI.MODELS + "/" + projectid + "/raw";
  }

  static readonly PROFILES = WebAPI.ROOT + "profiles";
  static CREATE_PROFILE(projectid: string): string {
    return WebAPI.PROFILES + "/" + projectid;
  }
  static PROFILE_PROPERTY(projectid: string): string {
    return WebAPI.PROFILES + "/" + projectid + "/property";
  }
  static GET_PROFILE(projectid: string, channel: string): string {
    return WebAPI.PROFILES + "/" + projectid + "/" + channel;
  }
  static UPDATE_PROFILE(
    projectid: string,
    channel: string,
    etag?: string
  ): string {
    let url = WebAPI.PROFILES + "/" + projectid + "/" + channel;
    if (etag && etag.length > 0) {
      url = url + "?" + this.ETAG + etag;
    }
    return url;
  }
  static DOWNLOAD_PROFILE(projectid: string): string {
    return WebAPI.PROFILES + "/" + projectid + "/raw";
  }

  static readonly NOTICES = WebAPI.ROOT + "notices";
  static readonly GET_NOTICES_COUNTS = WebAPI.NOTICES + "/counts";
  static readonly SET_NOTICES_READ = WebAPI.NOTICES + "/setread";

  static readonly LICENCES = WebAPI.ROOT + "licences";
  static readonly REGIST_SERIAL = WebAPI.LICENCES + "/serial";
  static readonly REGIST_CODE = WebAPI.LICENCES + "/code";
  static readonly REGIST_TERM = WebAPI.LICENCES + "/termcode";
  static UPDATE_SERIAL(serial: string) {
    return this.REGIST_SERIAL + "/" + serial;
  }

  static readonly SETTINGS = WebAPI.ROOT + "settings";

  /**
   * token有効期限切れhttpステータス
   */
  static readonly STATUS_BAD_TOKEN = 401;

  /**
   * httpステータスが存在しない場合のメッセージID
   */
  static readonly ID_SYSTEM_ERROR = "err_api_system_error";
  /**
   * ファイル件数が最大値を超える場合のメッセージID
   * ローカル判定用
   */
  static readonly ID_NUM_FILE_EXCEED = "err_api_num_file_exceed";
  /**
   * ファイルサイズが最大値を超える場合のメッセージID
   * ローカル判定用
   */
  static readonly ID_FILE_TOO_LARGE = "err_api_file_too_large";
  /**
   * チャネル選択で共通チャネルが存在しない場合のメッセージID
   * ローカル判定用
   */
  static readonly ID_NO_COMMON_CHANNEL = "err_no_common_channel";
}

export interface IFailCallbackParam {
  /**
   * WebAPIエラーの場合に呼び出されます
   * @callback fail
   * @param {string | undefined} id - メッセージID、致命的なエラーの場合はundefined
   * @param {number | undefined} status - httpステータスが存在ずる場合はhttpステータス、存在しない場合はundefined
   */
  fail: (id: string | undefined, status: number | undefined) => void;
}

export interface ISelectProjectParam {
  /**
   * プロジェクトID
   */
  projectid: string;
  /**
   * ETAG
   */
  etag?: string;
}

/**
 * any型
 */
// eslint-disable-next-line
export type AnyType = any;

/**
 * チャート行データ
 */
export type ChartRowData = AnyType[];

/**
 * チャート行データ配列
 */
export type ChartRowDataArray = ChartRowData[];
